import { isValidURL } from "../utility.service"

const GenesysChatBotScript = (options) => {
  try {
    if (!!options && !!options.url) {
      const { head, defer, async, beforeLoad } = options
      let url = options.url
      let {
        botID,
        authKey
      } = options.dataAttr

      if (
        !isValidURL(url) &&
        !botID &&
        !authKey
      ) {
        console.log(`Please verify the Genesys ChatBot configurations`)
        return
      }

      console.log(`Loading Genesys Chatbot`)

      // Initialize ChatLoader after script loads
      const onload = () => {
        const pageData = window.pageData || {}
        const botCountryCode = pageData.country || 'us'
        const botLang = pageData.language || 'en'
        const domainUrl = window.location.href

        if (typeof window.ChatLoader !== 'undefined') {
          try {
            window.ChatLoader.init({
              botLang,
              botId: botID,
              botAuthKey: authKey,
              domainUrl,
              botCountryCode
            })
            console.log(`Genesys ChatLoader initialized for country: ${botCountryCode}, language: ${botLang}`)
          } catch (e) {
            console.log(`Error initializing Genesys ChatLoader`)
          }
        } else {
          console.log(`ChatLoader is not available`)
        }
      }

      return {
        src: url,
        inHead: !!head,
        beforeLoad: !!beforeLoad,
        defer: !!defer,
        async: !!async,
        onload
      }
    }
  } catch (e) {
    console.log(`There is an error. Genesys ChatBot cannot be loaded.`)
  }
}

export default GenesysChatBotScript